document.addEventListener("DOMContentLoaded", function () {
  if (typeof Swiper !== "undefined") {
    setTimeout(function () {
      document.querySelectorAll(".swiper").forEach(function (slider) {
        if (slider.swiper && slider.swiper.params.pagination) {
          slider.swiper.params.pagination.dynamicBullets = true;
          slider.swiper.params.pagination.dynamicMainBullets = 5;

          slider.swiper.pagination.destroy();
          slider.swiper.pagination.init();
          slider.swiper.pagination.render();
          slider.swiper.pagination.update();
        }
      });
    }, 800); // delay so Shopify's theme JS finishes
  }
});
